import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { CurrencySignType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-track-marker',
  templateUrl: './bmcore-track-marker.component.html',
  styleUrls: ['./bmcore-track-marker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackMarkerComponent implements OnInit {
  @Input() currencySign: CurrencySignType
  @Input() isPromo: boolean | undefined
  @Input() ordinalNumber: number

  constructor() {}

  ngOnInit(): void {}
}
